
<footer class="footer">
  <div class="container-fluid">
    <div class="row footer-inner justify-content-between">
      <div class="col-md-12 col-lg-6 copyright-text">
        <app-copyright [showStrong]="false"></app-copyright>
      </div>
      <div class="col-md-12 col-lg-6 utc-timing-text">
        {{'Local Time' | translate}} : {{timeZoneOffset}}
      </div>
    </div>
  </div>
</footer>

